/* Velvet Vogue - product rows engine: classify + score + build rows */
(function (root) {
  'use strict';
  var W = function (s) { return new Set(s.split(' ')); };
  var COLORS = W('black brown beige white gray grey green red pink blue khaki burgundy cream navy camel yellow purple orange silver gold ivory tan olive champagne apricot');
  var FAM = { grey: 'gray', ivory: 'cream', tan: 'camel', champagne: 'beige', apricot: 'beige', khaki: 'beige', camel: 'brown', cream: 'white', olive: 'green', navy: 'blue', burgundy: 'red' };
  var NEUTRAL = W('black brown beige white gray camel khaki navy cream ivory tan silver');
  var STOP = W('for with and the in of a an to by on at from women womens woman s men mens unisex dress dresses fashion clothing apparel womens clothing new arrivals extended sizes inclusive sizing plus size velvet vogue adult fall winter autumn aw seasonal essentials cold weather outfit outfits style everyday department catalog group shopping category product type');
  var GENERIC = ['Department', 'Catalog Group', 'Shopping Category', 'Product Type', 'bron-', 'import-', 'comp-', 'varsovia', 'alverra', 'storenaut', 'copy-'];
  var BUCKETS = {
    formal: W('evening prom gown cocktail party wedding satin corset sequin sequins tulle formal elegant sparkle glitter ruched halter bodycon strapless metallic pearl chain stiletto slingback pumps patent bow occasion event guest gala holiday date night mary jane heels heeled bridal backless slit slip sweetheart mermaid fitted pointed'),
    cozy: W('knit knitted chunky fleece fur faux sherpa teddy plush cable ribbed waffle wool cashmere cozy warm lined quilted puffer hooded merino brushed thermal snow shearling fuzzy'),
    casual: W('casual relaxed oversized hoodie comfort orthopedic denim striped plaid argyle cargo sneakers trainers jersey cotton weekend sweatshirt graphic sporty utility lug platform waterproof trail'),
    classic: W('tailored blazer trench double breasted belted herringbone tweed structured classic timeless trouser wrap polished longline overcoat pencil midi coat leather lapel notch'),
    boho: W('western boho bohemian floral patchwork embroidered ruffle ruffled suede leopard print fringe crochet vintage retro aztec paisley')
  };
  var BIAS = { heels: { formal: 2 }, sneakers: { casual: 2 }, bag: { classic: 1, formal: 1 } };
  var mk = function (a) { var s = new Set(); a.forEach(function (x) { s.add(x); }); return s; };
  var T_DRESS = mk(['Dresses', 'Dresses & Jumpsuits', 'Jumpsuits', 'Knitted Jumper Dresses', 'Sparkle Party Mini Dresses', 'Floral Strapless A-Line Mini Dresses', 'Playsuits & Rompers']);
  var T_TOP = mk(['Cardigans', 'Sweaters', 'Sweaters & Knitwear', 'Blouses', 'Tops', 'Hoodies', 'Hoodies & Sweatshirts', 'Shirts', 'Christmas Jumpers', "Women's Christmas Turtleneck Sweaters", 'Sleepwear & Loungewear']);
  var T_OUT = mk(['Coats', 'Jackets', 'Blazers', 'Vests']);
  var T_BOT = mk(['Pants', 'Jeans', 'Skirts']);
  var T_FLAT = mk(['Shoes', 'Loafers', 'Clogs & Mules']);
  var K_HEEL = W('heels pumps slingback slingbacks stiletto'), K_SNK = W('sneakers trainers'), K_FLAT = W('loafers shoes mules sandals flats'),
    K_DRESS = W('dress gown jumpsuit romper playsuit'), K_OUT = W('coat jacket blazer overcoat gilet puffer parka trench bomber vest'),
    K_BOT = W('pants jeans trousers skirt leggings'), K_TOP = W('sweater cardigan jumper pullover hoodie top blouse shirt sweatshirt turtleneck'),
    K_BOOT = W('boots boot booties');

  var tok = function (s) { return (s || '').toLowerCase().match(/[a-z]+/g) || []; };
  var hit = function (tk, set) { var r = false; set.forEach(function (x) { if (tk.has(x)) r = true; }); return r; };
  var anyIn = function (list, arr) { for (var i = 0; i < arr.length; i++) if (list.indexOf(arr[i]) >= 0) return true; return false; };

  function group(p, tk) {
    var t = p.y;
    if (t === 'Shipping Protection' || t === 'Pet Carrier Hoodies' || t === 'Costumes' || p.h === 'shipping-protection' || (tk.has('pet') && tk.has('hoodie'))) return 'skip';
    if (t === 'Bags' || tk.has('bag')) return 'bag';
    if (t === 'Accessories' || tk.has('watch') || tk.has('bracelet')) return 'acc';
    if (t === 'Boots' || hit(tk, K_BOOT)) return 'boots';
    if (t === 'Heels' || hit(tk, K_HEEL)) return 'heels';
    if (t === 'Sneakers' || hit(tk, K_SNK)) return 'sneakers';
    if (T_FLAT.has(t) || hit(tk, K_FLAT)) return 'flats';
    if (T_DRESS.has(t) || hit(tk, K_DRESS)) return 'dress';
    if (t === 'Sets' || t === 'Matching Sets' || tk.has('set')) return 'set';
    if (T_OUT.has(t) || hit(tk, K_OUT)) return 'outer';
    if (T_BOT.has(t) || hit(tk, K_BOT)) return 'bottom';
    if (T_TOP.has(t) || hit(tk, K_TOP)) return 'top';
    return 'other';
  }
  function gender(p, tk) {
    var tg = p.g.map(function (x) { return x.toLowerCase(); });
    if (tk.has('women') || tk.has('womens') || tk.has('woman') || tk.has('lady') || tk.has('ladies')) return 'w';
    if (tk.has('men') || tk.has('mens') || tk.has('man') || tk.has('male')) return 'm';
    if (p.f.indexOf('w') >= 0) return 'w';
    if (p.f.indexOf('m') >= 0) return 'm';
    if (anyIn(tg, ['men', 'mens', 'department: men', 'fashion-men', 'mens apparel', 'men-sweater'])) return 'm';
    if (tk.has('unisex')) return 'u';
    return anyIn(tg, ['women', 'womens', 'womens fashion']) ? 'w' : 'u';
  }
  function descTokens(p) {
    var t = new Set(tok(p.t));
    var m = /^\s*([A-Za-z\-']+)\s*(\||–|—| - )/.exec(p.t);
    if (m) tok(m[1]).forEach(function (x) { t.delete(x); });
    p.g.forEach(function (tag) {
      if (tag === 'velvet vogue') return;
      for (var i = 0; i < GENERIC.length; i++) if (tag.indexOf(GENERIC[i]) === 0) return;
      tok(tag).forEach(function (x) { t.add(x); });
    });
    var out = new Set();
    t.forEach(function (x) { if (!STOP.has(x) && !COLORS.has(x) && x.length > 2) out.add(x); });
    return out;
  }
  function styleVec(p) {
    var v = {}, s = 0;
    Object.keys(BUCKETS).forEach(function (b) { var n = 0; p.dt.forEach(function (t) { if (BUCKETS[b].has(t)) n++; }); v[b] = n; });
    var bias = BIAS[p.grp];
    if (bias) Object.keys(bias).forEach(function (k) { v[k] += bias[k]; });
    Object.keys(v).forEach(function (b) { s += v[b]; });
    var o = {};
    Object.keys(v).forEach(function (b) { o[b] = s ? v[b] / s : 0; });
    p.sv = o; p.svn = s;
  }
  /* row = [handle,title,type,tags,flags,priceCents,compareCents,img] */
  function enrich(r) {
    var p = { h: r[0], t: r[1] || '', y: r[2] || '', g: r[3] || [], f: r[4] || '', p: (r[5] || 0) / 100, c: (r[6] || 0) / 100, i: r[7] || '' };
    var tk = new Set(tok(p.t));
    p.tk = tk;
    p.grp = group(p, tk);
    p.gen = gender(p, tk);
    p.colors = new Set(); p.g.forEach(function (x) { if (COLORS.has(x)) p.colors.add(x); });
    p.fam = new Set(); p.colors.forEach(function (c) { p.fam.add(FAM[c] || c); });
    p.dt = descTokens(p);
    styleVec(p);
    p.win = p.g.some(function (t) { return t === 'comp-winner' || t.indexOf('varsovia-best') === 0 || t === 'storenaut-optimized' || t.indexOf('import-kateandlucy') === 0; });
    p.best = p.f.indexOf('b') >= 0;
    p.disc = (p.c > p.p && p.p > 0) ? (1 - p.p / p.c) : 0;
    p.bad = tk.has('nan') || p.grp === 'skip' || p.grp === 'other';
    p.skirt = tk.has('skirt') || p.y === 'Skirts';
    return p;
  }

  var IDF = {}, DEF_IDF = 1;
  function setIdf(list) {
    var df = {}, n = list.length;
    list.forEach(function (p) { p.dt.forEach(function (t) { df[t] = (df[t] || 0) + 1; }); });
    IDF = {};
    Object.keys(df).forEach(function (t) { IDF[t] = Math.log((n + 1) / (df[t] + 1)) + 0.2; });
    DEF_IDF = Math.log(n + 1) + 0.2;
  }
  var idf = function (t) { var v = IDF[t]; return v === undefined ? DEF_IDF : v; };
  function wjac(a, b) {
    var i = 0, u = 0;
    a.forEach(function (t) { var w = idf(t); u += w; if (b.has(t)) i += w; });
    b.forEach(function (t) { if (!a.has(t)) u += idf(t); });
    return u ? i / u : 0;
  }
  function bsim(a, b) { var s = 0; Object.keys(a).forEach(function (k) { s += Math.min(a[k], b[k]); }); return s; }
  function inter(a, b) { var r = false; a.forEach(function (x) { if (b.has(x)) r = true; }); return r; }
  function colorScore(s, c) {
    if (inter(s.fam, c.fam)) return 2.0;
    if (inter(s.colors, NEUTRAL) && inter(c.colors, NEUTRAL)) return 1.0;
    return 0.0;
  }
  function priceScore(s, c) {
    if (s.p <= 0 || c.p <= 0) return 0;
    var r = c.p / s.p;
    if (r >= 0.6 && r <= 1.6) return 0.6;
    if (r >= 0.4 && r <= 2.5) return 0.2;
    return -0.3;
  }
  function quality(c) { return (c.win ? 1 : 0) + Math.min(c.disc, 0.6) * 0.8; }
  function score(s, c) {
    var sc = colorScore(s, c) + priceScore(s, c) + quality(c);
    if (s.grp === c.grp) {
      sc += 7.0 * wjac(s.dt, c.dt) + 1.5 * bsim(s.sv, c.sv);
    } else {
      sc += 3.0 * bsim(s.sv, c.sv) + 2.0 * wjac(s.dt, c.dt);
      if (s.sv.formal > 0.4 && c.sv.casual > 0.4) sc -= 2;
      if (c.grp === 'sneakers' && (s.grp === 'dress' || s.grp === 'heels' || s.grp === 'bag')) sc -= 4;
      if (c.grp === 'outer' && (s.grp === 'dress' || s.grp === 'heels' || s.grp === 'bag') && c.sv.classic > 0) sc += 0.8;
    }
    return sc;
  }
  var genOk = function (s, c) { return s.gen === 'm' ? (c.gen === 'm' || c.gen === 'u') : (c.gen === 'w' || c.gen === 'u'); };

  /* ---------- copy ---------- */
  function shortName(title) {
    var t = String(title || '').replace(/^\s*[A-Za-z\-']+\s*(\||–|—| - )\s*/, '');
    t = t.split(',')[0].replace(/\s+for (Women|Men)\b.*$/i, '').replace(/^(Women|Men)(’|')s\s+/i, '').replace(/\s+/g, ' ').trim();
    if (t.length > 42) { t = t.slice(0, 42); t = t.slice(0, t.lastIndexOf(' ') > 18 ? t.lastIndexOf(' ') : 42).replace(/[\s\-–|&]+$/, '') + '…'; }
    return t || 'this item';
  }
  var KIND = { dress: 'dresses', set: 'sets', outer: 'coats & jackets', top: 'tops', bottom: 'pants', boots: 'boots', heels: 'heels', sneakers: 'sneakers', flats: 'shoes', bag: 'bags', acc: 'accessories' };
  function kindOf(s) {
    var k = KIND[s.grp] || '', t = s.tk;
    if (s.grp === 'bottom') return s.skirt ? 'skirts' : (t.has('jeans') ? 'jeans' : 'pants');
    if (s.grp === 'dress' && (t.has('jumpsuit') || t.has('romper') || t.has('playsuit')) && !t.has('dress')) return 'jumpsuits';
    if (s.grp === 'top') return t.has('hoodie') ? 'hoodies' : t.has('cardigan') ? 'cardigans' : (t.has('sweater') || t.has('jumper') || t.has('pullover')) ? 'sweaters' : 'tops';
    if (s.grp === 'outer') return (t.has('blazer') && !t.has('coat')) ? 'blazers' : 'coats & jackets';
    return k;
  }
  function rowDefs(src) {
    var m = src.gen === 'm', g = m ? "Men's" : "Women's";
    return [
      { k: 'outer', g: ['outer'], title: g + ' winter coats & jackets',
        cross: 'Warm layers picked to go with the {n}.', same: 'Every coat & jacket we have, closest to the {n} first.' },
      m ? { k: 'top', g: ['top'], title: "Men's sweaters, knits & tops",
        cross: 'Sweaters, knits & tops to wear with the {n}.', same: 'Every sweater & top we have, closest to the {n} first.' }
        : { k: 'dress', g: ['dress', 'set'], title: "Women's dresses, jumpsuits & sets",
        cross: 'Dresses that match the mood of the {n}.', same: 'Every dress & set we have, closest to the {n} first.' },
      { k: 'bottom', g: ['bottom'], title: g + (m ? ' pants & jeans' : ' pants, jeans & skirts'),
        cross: 'Pants & jeans that work with the {n}.', same: 'Every pair we have, closest to the {n} first.' },
      { k: 'shoes', g: ['boots', 'heels', 'sneakers', 'flats'], title: g + ' shoes & boots',
        cross: 'Shoes & boots to finish the look with the {n}.', same: 'Every pair of shoes we have, closest to the {n} first.' }
    ];
  }

  function build(srcRow, rows) {
    var all = rows.map(enrich);
    setIdf(all);
    var src = enrich(srcRow);
    var pool = all.filter(function (c) { return !c.bad && !c.best && c.h !== src.h && genOk(src, c); });
    var used = new Set([src.h]), picks = {};
    function dup(c) {
      if (c.grp === src.grp && wjac(c.dt, src.dt) >= 0.84) return true;
      var a = picks[c.grp] || [];
      for (var i = 0; i < a.length; i++) if (wjac(c.dt, a[i].dt) >= 0.84) return true;
      return false;
    }
    function rank(list, adj) {
      var sc = list.map(function (c) { return { c: c, s: score(src, c) + (adj ? adj(c) : 0) }; });
      sc.sort(function (a, b) { return (b.s - a.s) || (a.c.h < b.c.h ? -1 : 1); });
      return sc.map(function (x) { return x.c; });
    }
    function take(list, limit) {
      var out = [];
      for (var i = 0; i < list.length && (!limit || out.length < limit); i++) {
        var c = list[i];
        if (used.has(c.h) || dup(c)) continue;
        out.push(c); used.add(c.h); (picks[c.grp] = picks[c.grp] || []).push(c);
      }
      return out;
    }
    var defs = rowDefs(src), n = shortName(src.t);
    var covered = defs.some(function (d) { return d.g.indexOf(src.grp) >= 0; });
    var res = [];
    /* row 1: exact comparable */
    var same = pool.filter(function (c) { return c.grp === src.grp; });
    var cap = 0;
    if (covered) {
      cap = Math.min(14, Math.max(4, Math.floor(same.length / 2)));
      if (same.length - cap < 4) cap = 0;
    }
    var r1 = take(rank(same), cap);
    if (r1.length) res.push({ key: 'similar', title: 'More ' + (kindOf(src) ? kindOf(src) + ' ' : '') + 'like this', sub: 'The closest matches to the ' + n + ' – same style, same look.', items: r1 });
    /* rows 2-5: categories, never mixing men / women */
    defs.forEach(function (d) {
      var cands = pool.filter(function (c) { return d.g.indexOf(c.grp) >= 0 && !used.has(c.h); });
      var mine = d.g.indexOf(src.grp) >= 0;
      var items = take(rank(cands, function (c) {
        var a = mine && c.grp === src.grp ? 100 : 0;
        if (d.k === 'bottom' && c.skirt) a -= 1.5;
        if (d.k === 'outer' && (c.tk.has('blazer') || c.tk.has('vest')) && !c.tk.has('coat') && !c.tk.has('jacket')) a -= 6;
        return a;
      }), 0);
      if (!items.length) return;
      res.push({ key: d.k, title: d.title, sub: (d.g.indexOf(src.grp) >= 0 ? d.same : d.cross).replace('{n}', n), items: items });
    });
    return { src: src, name: n, rows: res };
  }

  function slim(r) {
    var keep = r[3].filter(function (t) {
      if (/^Department: Men$/i.test(t) || t === 'comp-winner' || t === 'storenaut-optimized' || t.indexOf('varsovia-best') === 0 || t.indexOf('import-kateandlucy') === 0) return true;
      for (var i = 0; i < GENERIC.length; i++) if (t.indexOf(GENERIC[i]) === 0) return false;
      return true;
    });
    return [r[0], r[1], r[2], keep, r[4], r[5], r[6], r[7]];
  }

  var API = { enrich: enrich, setIdf: setIdf, score: score, build: build, slim: slim };
  if (typeof module !== 'undefined' && module.exports) module.exports = API; else root.VVR = API;
})(typeof window !== 'undefined' ? window : this);